<template>
  <ValidationObserver ref="observer" class="validation posr" v-slot="{ handleSubmit }">
    <form id="surveyForm" class="form-box"  @submit.prevent="handleSubmit(onSubmit)">
      <ValidationProvider
          tag="div"
          class="mb-3 posr"
          :rules="{ required: true, email: true }"
          v-slot="{ errors }"
        >
        <label class="form-label">Email Address</label>
        <input type="email" v-model="email" class="form-control">
        <div class="error">{{ errors[0] }}</div>
      </ValidationProvider>
      <ValidationProvider tag="div" class="mb-3 posr" rules="required" v-slot="{ errors }">
        <label class="form-label">購買者姓名</label>
        <input type="text" class="form-control" v-model="name" />
        <div class="error">{{ errors[0] }}</div>
      </ValidationProvider>
      <div class="ar_box">
        <div class="block">
          <div class="row g-1">
            <div class="col-lg-4 col-5">
              <label class="form-label">賣場名稱</label>
              <select class="form-select mb-3" v-model="store_id">
                <option v-for="(store, index) in stores" :key="`store${index}`" :value="store.id">
                  {{ store.title }}
                </option>
              </select>
            </div>
            <ValidationProvider
                tag="div"
                class="col-lg-8 col-7 posr"
                :rules="{
                  required: true,
                  regex: new RegExp(
                    `^[A-Za-z0-9_-]{${
                      stores.find((store) => store.id == store_id).order_no_length
                    }}$`
                  ),
                }"
                v-slot="{ errors }"
              >
                <label class="form-label">訂單號碼</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="order_no"
                    class="form-control"
                    :placeholder="`共${stores.find(store => store.id == store_id).order_no_length} 碼 (${stores.find((store) => store.id == store_id).placeholder})`"
                  />
                </div>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="ar_box">
        <div
          v-for="(bought_item, index) in bought_items"
          :key="`bought_item${index}`"
          class="block"
        >
          <div class="row g-1">
            <div class="col-8">
              <label class="form-label">購買商品</label>
                <ValidationProvider
                  tag="div"
                  class="posr"
                  :rules="{
                    required: true,
                    unique_item: {
                      bought_items: bought_items,
                      current_index: index
                    }
                  }"
                  v-slot="{ errors }"
                >
                  <select class="form-select mb-3" v-model="bought_items[index].id">
                    <option v-for="(item, j) in items" :key="`item${j}`" :value="item.id">
                      {{ item.title }}
                    </option>
                  </select>
                  <div class="error">{{ errors[0] }}</div>
                </ValidationProvider>
            </div>
            <div class="col-4">
              <label class="form-label">商品數量</label>
                <ValidationProvider
                  tag="div"
                  class="input-group mb-3 posr"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="number"
                    :class="`form-control ${index >= 1 ? 'remove-qty-input' : ''}`"
                    v-model="bought_items[index].qty"
                    min="1"
                    step="1"
                    required
                  />
                  <span
                    v-if="index >= 1"
                    class="btn input-group-text remove_btn"
                    @click.prevent="removeItem(index)"
                    >-</span
                  >
                  <div class="item-error">{{ errors[0] }}</div>
                </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="yes">
          <span class="btn add_btn" @click.prevent="addItem">+</span>
        </div>
      </div>
      <div v-for="(field, index) in dynamic_field_labels" :key="`dynamic_field${index}`" class="mb-3">
        <label class="form-label">
          <!-- 若為必填則顯示紅色星號 -->
          <span v-if="field.split('|')[1] === 'true'" class="text-danger">*</span>{{ field.split('|')[0] }}
        </label>
        <ValidationProvider
          tag="div"
          class="input-group mb-3 posr"
          :rules="{ required: field.split('|')[1] === 'true' }"
          v-slot="{ errors }"
        >
          <input type="text" class="form-control" v-model="dynamic_fields[index].value" />
          <div class="item-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="mb-3">
        <label class="form-label">備註</label>
        <input type="text" class="form-control" v-model="comment" />
      </div>
      <blockquote class="alert alert-danger mt-3">
        <p v-html="privacy"></p>
        <div class="form-check agree_box">
            <input
              type="checkbox"
              class="form-check-input agree"
              name="agree"
              id="agree"
              v-model="agreed"
            />
          <label class="form-check-label" for="agree">我同意</label>
        </div>
      </blockquote>
      <div class="agree_center">
        <button type="submit" class="d-grid col-md-6 col-8 mx-auto btn" :disabled="!agreed">資料送出</button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import swal from "sweetalert";
import { extend } from "vee-validate";
import { required, regex, email } from "vee-validate/dist/rules";
import axios from "axios";

var csrf = $("meta[name=csrf-token]").attr("content");
axios.defaults.headers.common["X-CSRF-Token"] = csrf;

extend("required", {
  ...required,
  message: "必填欄位！",
});

extend("regex", {
  ...regex,
  message: "欄位格式錯誤，請檢查長度！",
});

extend("email", {
  ...email,
  message: "請輸入Email格式!",
});

// 新增自定義驗證規則：檢查商品是否重複
extend("unique_item", {
  params: ["bought_items", "current_index"],
  validate(value, { bought_items, current_index }) {
    // 檢查當前選擇的商品是否在其他位置已被選擇
    const duplicateCount = bought_items.filter((item, index) =>
      item.id == value && index != current_index
    ).length;
    return duplicateCount === 0;
  },
  message: "此商品已被選擇，請選擇其他商品！",
});


export default {
  name: "SurveyForm",
  props: ["privacy", "stores", "items", "code", "dynamic_field_labels"],
  data() {
    return {
      email: "",
      name: "",
      store_id: this.stores[0] && this.stores[0].id,
      order_no: "",
      comment: "",
      dynamic_fields: this.dynamic_field_labels.map(field => ""),
      bought_items: [
        {
          id: this.items[0] && this.items[0].id,
          qty: 1,
        },
      ],
      agreed: false,
    };
  },
  watch: {
    // 監聽購買商品的變化，當任何商品改變時重新驗證所有商品選擇器
    bought_items: {
      handler() {
        this.$nextTick(() => {
          // 延遲一點時間再重新驗證，確保 DOM 已更新
          setTimeout(() => {
            if (this.$refs.observer) {
              this.$refs.observer.validate();
            }
          }, 100);
        });
      },
      deep: true, // 深度監聽陣列內物件的變化
    },
  },
  methods: {
    addItem() {
      this.bought_items.push({
        id: this.items[0] && this.items[0].id,
        qty: 1,
      });
    },
    removeItem(index) {
      this.bought_items.splice(index, 1);
    },
    onSubmit() {
      // agreed才能送出
      if (!this.agreed) {
        swal("請勾選同意", "請勾選同意", "warning");
        return;
      }
      // 送出資料
      const { code, email, name, store_id, order_no, comment, bought_items, dynamic_fields } = this;
      // console.log(bought_items, "<==== bought_items");
      axios
        .post("/campaigns", {
          survey: {
            email,
            name,
            store_id,
            order_no,
            comment,
            dynamic_fields, // 添加動態欄位資料
          },
          code,
          bought_items,
        })
        .then(({ data }) => {
          // console.log(data);
          if (data.status == "success") {
            swal("資料送出成功", "感謝您的填寫", "success").then(() => {
              window.location.href = "/surveys/" + data.survey_key;
            });
          } else {
            swal("資料送出失敗", data.message, "error");
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
